/* ============================================================
   design—light · Header B behavior
   - hover-intent mega panels (desktop) + click toggle (touch)
   - scrim + Escape close
   - mobile drawer + accordions
   - equal-area brand logo normalization
   ============================================================ */
(function () {
  var root = document.querySelector("[data-navx]");
  if (!root) return;

  var cats = Array.prototype.slice.call(root.querySelectorAll(".navx-cat[data-panel]"));
  var panels = Array.prototype.slice.call(root.querySelectorAll(".navx-panel"));
  var scrim = root.querySelector(".navx-scrim");
  var desktop = window.matchMedia("(min-width: 1024px)");
  var openTimer = null, closeTimer = null, current = null;

  function openPanel(id) {
    clearTimeout(closeTimer);
    panels.forEach(function (p) { p.classList.toggle("open", p.dataset.id === id); });
    cats.forEach(function (c) { c.classList.toggle("on", c.dataset.panel === id); });
    current = id;
    root.classList.add("dim");
  }
  function closePanels() {
    panels.forEach(function (p) { p.classList.remove("open"); });
    cats.forEach(function (c) { c.classList.remove("on"); });
    current = null;
    root.classList.remove("dim");
  }
  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closePanels, 160);
  }

  cats.forEach(function (cat) {
    cat.addEventListener("mouseenter", function () {
      if (!desktop.matches) return;
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { openPanel(cat.dataset.panel); }, current ? 0 : 70);
    });
    cat.addEventListener("mouseleave", function () {
      if (!desktop.matches) return;
      clearTimeout(openTimer);
      scheduleClose();
    });
    cat.addEventListener("click", function (e) {
      // touch / keyboard: first activation opens the panel, second follows the link
      if (current === cat.dataset.panel && cat.getAttribute("href") && cat.getAttribute("href") !== "#") return;
      e.preventDefault();
      current === cat.dataset.panel ? closePanels() : openPanel(cat.dataset.panel);
    });
  });
  panels.forEach(function (p) {
    p.addEventListener("mouseenter", function () { clearTimeout(closeTimer); });
    p.addEventListener("mouseleave", function () { if (desktop.matches) scheduleClose(); });
  });
  if (scrim) scrim.addEventListener("click", closePanels);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closePanels(); });
  desktop.addEventListener("change", closePanels);

  /* ---- mobile drawer ---- */
  var drawer = document.querySelector("[data-navx-drawer]");
  var burger = root.querySelector(".navx-burger");
  if (drawer && burger) {
    burger.addEventListener("click", function () { drawer.classList.add("open"); });
    var x = drawer.querySelector(".x");
    if (x) x.addEventListener("click", function () { drawer.classList.remove("open"); });
    Array.prototype.forEach.call(drawer.querySelectorAll(".navx-acc .t"), function (t) {
      t.addEventListener("click", function () { t.closest(".navx-acc").classList.toggle("open"); });
    });
  }

  /* ---- search takeover (Shopify predictive search) ---- */
  var sroot = root.querySelector("[data-navx-search]");
  if (sroot) {
    var sinput = sroot.querySelector("[data-search-input]");
    var sclear = sroot.querySelector("[data-search-clear]");
    var sug = sroot.querySelector("[data-sug]");
    var sres = sroot.querySelector("[data-sres]");
    var sempty = sroot.querySelector("[data-search-empty]");
    var sugTitle = sroot.querySelector("[data-sug-title]");
    var resTitle = sroot.querySelector("[data-res-title]");
    var sall = sroot.querySelector("[data-search-all]");
    var defaultSug = sug.innerHTML, defaultRes = sres.innerHTML;
    var defSugTitle = sugTitle.textContent, defResTitle = resTitle.textContent, defAll = sall.innerHTML;
    var lastReq = 0, selIdx = -1;

    function openSearch() {
      closePanels();
      if (drawer) drawer.classList.remove("open");
      sroot.hidden = false;
      document.body.style.overflow = "hidden";
      requestAnimationFrame(function () { sroot.classList.add("open"); sinput.focus(); });
    }
    function closeSearch() {
      sroot.classList.remove("open");
      document.body.style.overflow = "";
      setTimeout(function () { sroot.hidden = true; }, 200);
    }
    function esc(s) { return (s == null ? "" : String(s)).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
    function nrm(s) { return (s == null ? "" : String(s)).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""); }
    function hl(t, q) { t = t == null ? "" : String(t); if (!q) return esc(t); var i = nrm(t).indexOf(nrm(q)); if (i < 0) return esc(t); return esc(t.slice(0, i)) + "<mark>" + esc(t.slice(i, i + q.length)) + "</mark>" + esc(t.slice(i + q.length)); }

    function restoreDefault() {
      lastReq++; // invalidate any in-flight suggest request
      sroot.classList.remove("searching");
      sug.innerHTML = defaultSug; sres.innerHTML = defaultRes;
      sugTitle.textContent = defSugTitle; resTitle.textContent = defResTitle;
      sall.innerHTML = defAll; sall.setAttribute("href", sall.dataset.home || "/collections/all");
      sempty.hidden = true; sres.hidden = false; selIdx = -1;
    }

    function render(q, data) {
      var r = (data && data.resources && data.resources.results) || {};
      var queries = r.queries || [], colls = r.collections || [], prods = r.products || [];
      sugTitle.textContent = "Návrhy"; resTitle.textContent = "Produkty";
      var items = [];
      queries.slice(0, 4).forEach(function (x) { items.push({ url: x.url, t: x.title, ct: "" }); });
      colls.slice(0, 3).forEach(function (x) { items.push({ url: x.url, t: x.title, ct: "kolekce" }); });
      sug.innerHTML = items.length
        ? items.map(function (s) { return '<a href="' + s.url + '"><span>' + hl(s.t, q) + "</span>" + (s.ct ? '<span class="ct">' + s.ct + "</span>" : "") + "</a>"; }).join("")
        : '<a class="none"><span>Žádné návrhy</span></a>';
      if (prods.length) {
        sres.hidden = false; sempty.hidden = true;
        sres.innerHTML = prods.slice(0, 10).map(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image || "";
          return '<a class="pcard" href="' + p.url + '">' +
            '<span class="th">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : "") + '<span class="pr">' + esc(p.price || "") + "</span></span>" +
            '<span class="nm">' + hl(p.title, q) + "</span>" +
            '<span class="br">' + hl(p.vendor || "", q) + "</span></a>";
        }).join("");
      } else {
        sres.hidden = true; sempty.hidden = false;
        sempty.innerHTML = 'Pro <b>„' + esc(q) + '“</b> jsme nenašli žádné produkty. Zkuste „závěsná“, „artemide“ nebo „kabel“.';
      }
      var all = sall.dataset.base || "/search";
      sall.setAttribute("href", all + "?q=" + encodeURIComponent(q) + "&type=product");
      sall.innerHTML = 'Všechny výsledky pro „' + esc(q) + '“ <span>→</span>';
      selIdx = -1;
    }

    var t = null;
    function onInput() {
      var q = sinput.value.trim();
      sclear.hidden = !q;
      clearTimeout(t);
      if (!q) { restoreDefault(); return; }
      sroot.classList.add("searching");
      t = setTimeout(function () {
        var id = ++lastReq;
        fetch("/search/suggest.json?q=" + encodeURIComponent(q) +
              "&resources[type]=query,collection,product&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last", { headers: { "Accept": "application/json" } })
          .then(function (res) { return res.json(); })
          .then(function (data) { if (id === lastReq) render(q, data); })
          .catch(function () { if (id === lastReq) { sres.hidden = true; sempty.hidden = false; sempty.textContent = "Vyhledávání je dočasně nedostupné."; } });
      }, 180);
    }

    sall.dataset.home = sall.getAttribute("href") || "/collections/all";
    sall.dataset.base = sall.getAttribute("data-base") || "/search";
    sinput.addEventListener("input", onInput);
    sclear.addEventListener("click", function () { sinput.value = ""; sclear.hidden = true; restoreDefault(); sinput.focus(); });
    sroot.querySelector("[data-search-close]").addEventListener("click", closeSearch);
    Array.prototype.forEach.call(root.querySelectorAll("[data-search-open]"), function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); openSearch(); });
    });
    if (drawer) Array.prototype.forEach.call(drawer.querySelectorAll("[data-search-open]"), function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); openSearch(); });
    });

    sinput.addEventListener("keydown", function (e) {
      var links = Array.prototype.slice.call(sug.querySelectorAll("a[href]"));
      if (e.key === "ArrowDown") { e.preventDefault(); selIdx = Math.min(links.length - 1, selIdx + 1); }
      else if (e.key === "ArrowUp") { e.preventDefault(); selIdx = Math.max(-1, selIdx - 1); }
      else if (e.key === "Enter") {
        if (selIdx > -1 && links[selIdx]) { window.location = links[selIdx].getAttribute("href"); return; }
        var q = sinput.value.trim(); if (q) window.location = (sall.dataset.base || "/search") + "?q=" + encodeURIComponent(q) + "&type=product";
        return;
      } else if (e.key === "Escape") { return; }
      links.forEach(function (a, i) { a.classList.toggle("sel", i === selIdx); });
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !sroot.hidden) { if (sinput.value) { sinput.value = ""; sclear.hidden = true; restoreDefault(); } else closeSearch(); } });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "/" || !sroot.hidden) return;
      var t = e.target, tag = t && t.tagName ? t.tagName.toLowerCase() : "";
      if (tag === "input" || tag === "textarea" || (t && t.isContentEditable)) return;
      e.preventDefault();
      openSearch();
    });
  }

  /* ---- equal PERCEIVED logo size: equal-area normalization ----
     Wide wordmarks get less height, compact marks more, so every
     logo occupies roughly the same visual area. Expects cutout
     logos (tight viewBox / no baked-in clear-space). */
  Array.prototype.forEach.call(document.querySelectorAll(".navx-btile img"), function (img) {
    var fit = function () {
      var r = (img.naturalWidth && img.naturalHeight) ? img.naturalWidth / img.naturalHeight : 4;
      var m = img.closest(".navx-mbrands") ? 0.78 : 1;
      img.style.height = (Math.max(17, Math.min(42, Math.sqrt(3400 / r))) * m).toFixed(1) + "px";
    };
    (img.complete && img.naturalWidth) ? fit() : img.addEventListener("load", fit, { once: true });
  });
})();
/* ============================================================
   Megamenu v2 — rail hover-swap (appended 2026-08-01)
   Left links carry data-rail-target, rails carry data-rail.
   Desktop only; links remain real <a>s (keyboard = focus swap).
   ============================================================ */
(function () {
  var root = document.querySelector("[data-navx]");
  if (!root) return;
  var desktop = window.matchMedia("(min-width: 1024px)");
  /* 2026-10-26 (perf): one panel at a time and callable later. With lazy rails the panels arrive
     with an empty .navx-railwrap; the loader at the end of this file calls DLNavxRails.bind(panel)
     once the rails are in. The guard keeps a panel from being bound twice. */
  function bind(panel) {
    if (panel.getAttribute("data-rails-bound")) return;
    var links = Array.prototype.slice.call(panel.querySelectorAll("[data-rail-target]"));
    var rails = Array.prototype.slice.call(panel.querySelectorAll("[data-rail]"));
    if (!links.length || !rails.length) return;
    panel.setAttribute("data-rails-bound", "1");
    var visible = null;
    rails.forEach(function (r) { if (!r.hidden && !visible) visible = r; });
    var cur = visible ? visible.getAttribute("data-rail") : null;
    var timer = null;
    function byId(id) {
      var hit = null;
      rails.forEach(function (r) { if (r.getAttribute("data-rail") === id) hit = r; });
      return hit;
    }
    function swap(id) {
      if (id === cur) return;
      var to = byId(id);
      if (!to) return;
      var from = byId(cur);
      cur = id;
      links.forEach(function (a) { a.classList.toggle("on", a.getAttribute("data-rail-target") === id); });
      if (from) from.classList.add("fade");
      clearTimeout(timer);
      timer = setTimeout(function () {
        rails.forEach(function (r) {
          r.hidden = r.getAttribute("data-rail") !== id;
          if (r !== to) r.classList.remove("fade");
        });
        Array.prototype.forEach.call(panel.querySelectorAll("[data-rail-spot]"), function (sp) {
          sp.hidden = sp.getAttribute("data-rail-spot") !== id;
        });
        to.classList.add("fade");
        requestAnimationFrame(function () { requestAnimationFrame(function () { to.classList.remove("fade"); }); });
      }, 130);
    }
    links.forEach(function (a) {
      function go() { if (desktop.matches) swap(a.getAttribute("data-rail-target")); }
      a.addEventListener("mouseenter", go);
      a.addEventListener("focus", go);
    });
  }
  Array.prototype.forEach.call(root.querySelectorAll(".navx-panel[data-rails]"), bind);
  window.DLNavxRails = { bind: bind };
})();

/* ============================================================
   Megamenu v3.1 — rail carousel arrows (appended 2026-08-02)
   One visible row of 3 tiles; ‹ › scroll the active rail by
   one tile. Buttons hide when the rail fits (≤3 products).
   ============================================================ */
(function () {
  var root = document.querySelector("[data-navx]");
  if (!root) return;
  Array.prototype.forEach.call(root.querySelectorAll(".navx-panel[data-rails] .navx-railwrap"), function (wrap) {
    function mk(dir, path) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "navx-rnav " + (dir < 0 ? "prev" : "next");
      b.setAttribute("aria-label", dir < 0 ? "Předchozí produkty" : "Další produkty");
      b.innerHTML = '<svg viewBox="0 0 24 24"><path d="' + path + '"></path></svg>';
      b.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation();
        var r = wrap.querySelector(".navx-rail:not([hidden])");
        if (!r) return;
        var card = r.firstElementChild;
        var step = card ? card.getBoundingClientRect().width + 2 : r.clientWidth / 3;
        r.scrollBy({ left: dir * step, behavior: "smooth" });
      });
      wrap.appendChild(b);
      return b;
    }
    var prev = mk(-1, "m15 18-6-6 6-6");
    var next = mk(1, "m9 6 6 6-6 6");
    function update() {
      var r = wrap.querySelector(".navx-rail:not([hidden])");
      if (!r) { prev.disabled = next.disabled = true; return; }
      var fits = r.scrollWidth <= r.clientWidth + 4;
      prev.disabled = fits || r.scrollLeft <= 2;
      next.disabled = fits || r.scrollLeft + r.clientWidth >= r.scrollWidth - 2;
    }
    /* 2026-10-26 (perf): one capturing listener on the wrap instead of one per rail, so rails that
       arrive later (lazy rails, see the end of this file) are covered too. Scroll does not bubble,
       but a capturing listener on an ancestor still receives it. */
    wrap.addEventListener("scroll", update, { passive: true, capture: true });
    wrap.addEventListener("mouseenter", update);
    wrap.addEventListener("mouseover", update);
    update();
  });
})();
/* ============================================================
   Megamenu v3.2 — equal panel height (appended 2026-08-02)
   All product panels share the height of the TALLEST left
   column, so the panel bottom edge and tile size are identical
   no matter which menu item is open.
   ============================================================ */
(function () {
  var root = document.querySelector("[data-navx]");
  if (!root) return;
  var t = null;
  function equalize() {
    var panels = Array.prototype.slice.call(root.querySelectorAll(".navx-panel.navx-p3"));
    if (!panels.length) return;
    var max = 0;
    panels.forEach(function (p) {
      var links = p.querySelector(".navx-plinks");
      if (!links) return;
      var wasOpen = p.classList.contains("open");
      var prev = p.getAttribute("style") || "";
      if (!wasOpen) p.style.cssText = prev + ";display:block;visibility:hidden;position:absolute;left:-99999px;top:0;right:auto;width:1200px;";
      links.style.minHeight = "";
      var h = links.offsetHeight;
      if (h > max) max = h;
      if (!wasOpen) { if (prev) p.setAttribute("style", prev); else p.removeAttribute("style"); }
    });
    if (max > 0) panels.forEach(function (p) {
      var links = p.querySelector(".navx-plinks");
      if (links) links.style.minHeight = max + "px";
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", equalize);
  else equalize();
  window.addEventListener("resize", function () { clearTimeout(t); t = setTimeout(equalize, 150); });
})();
/* ============================================================
   Megamenu v3.3 — half-tile peek (appended 2026-08-02)
   Tile width is tuned per rail so exactly N full tiles + a
   half tile are visible — a clear hint that more items follow.
   ============================================================ */
(function () {
  var root = document.querySelector("[data-navx]");
  if (!root || !window.ResizeObserver) return;
  function fit(wrap) {
    var w = wrap.clientWidth, h = wrap.clientHeight;
    if (w < 100 || h < 100) return;
    var ideal = h * 0.75;
    var n = Math.max(2, Math.round(w / ideal - 0.5));
    var tw = (w - n * 2) / (n + 0.5);
    wrap.style.setProperty("--dl-tw", tw.toFixed(1) + "px");
  }
  var ro = new ResizeObserver(function (entries) {
    entries.forEach(function (e) { fit(e.target); });
  });
  Array.prototype.forEach.call(root.querySelectorAll(".navx-panel.navx-p3 .navx-railwrap"), function (w) { ro.observe(w); });
})();

/* v3.3a */

/* ============================================================
   Lazy rails (2026-10-26, perf — night season run)
   sections/dl-header-b.liquid prints every mega panel with an
   EMPTY .navx-railwrap[data-rails-lazy] (the ~280 product cards
   were 75 % of every page's DOM). This fetches the header section
   once, with the rails, and moves each panel's rails in:
     GET /search?q=dl-navx-rails&type=page&view=rails
   (the Liquid prints the rails only for that query). 2026-10-30: the
   first version asked for the header alone with section_id=<group
   section id>, but Shopify answers 404 for sections that live in a
   section group (checked on the live store), so the request is the
   whole page on the alternate template templates/search.rails.json
   (one empty section: only the layout with the header renders; a
   store without that template falls back to the normal search page,
   which carries the same header). The response is parsed as a
   document and only the panels' rails are taken from it. Triggers:
   first pointer / focus on the category bar, a tap on a category,
   and idle ~1.5 s after load on a desktop with a mouse — so a
   desktop hover finds them ready. Phones never fetch: the mobile
   drawer has no rails. Cached 10 min per tab (sessionStorage).
   On failure the panels keep their left links (plain <a>s) and
   the next trigger tries again.
   ============================================================ */
(function () {
  var root = document.querySelector("[data-navx]");
  if (!root) return;
  var wraps = Array.prototype.slice.call(root.querySelectorAll(".navx-railwrap[data-rails-lazy]"));
  if (!wraps.length) return;
  var sec = root.closest(".shopify-section");
  var sid = sec && sec.id ? sec.id.replace(/^shopify-section-/, "") : "";
  if (!sid) return;
  var KEY = "dl-navx-rails:" + sid + ":" + (root.getAttribute("data-rails-key") || ""), TTL = 10 * 60 * 1000;
  var state = 0; /* 0 idle · 1 loading · 2 done */

  function inject(map) {
    wraps.forEach(function (w) {
      var panel = w.closest(".navx-panel");
      var id = panel && panel.getAttribute("data-id");
      if (!id || typeof map[id] !== "string" || !w.hasAttribute("data-rails-lazy")) return;
      var tpl = document.createElement("template");
      tpl.innerHTML = map[id];
      w.insertBefore(tpl.content, w.firstChild); /* before the ‹ › buttons, as when server-rendered */
      w.removeAttribute("data-rails-lazy");
      if (window.DLNavxRails) window.DLNavxRails.bind(panel);
      w.dispatchEvent(new Event("mouseenter")); /* refresh the ‹ › state */
    });
    if (typeof window.dlNavxPriceMove === "function") window.dlNavxPriceMove();
  }
  function parse(html) {
    var doc = new DOMParser().parseFromString(html, "text/html"), map = {}, n = 0;
    Array.prototype.forEach.call(doc.querySelectorAll(".navx-panel[data-id] .navx-railwrap"), function (w) {
      var id = w.closest(".navx-panel").getAttribute("data-id");
      if (w.querySelector("[data-rail]")) { map[id] = w.innerHTML.trim(); n++; }
    });
    return n ? map : null;
  }
  function load() {
    if (state) return;
    state = 1;
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || "null");
      if (c && c.m && Date.now() - c.t < TTL) {
        inject(c.m);
        if (!root.querySelector(".navx-railwrap[data-rails-lazy]")) { state = 2; return; }
        /* the menu changed since the copy was cached: fetch the rest */
      }
    } catch (e) {}
    fetch("/search?q=dl-navx-rails&type=page&options%5Bprefix%5D=none&view=rails", { credentials: "same-origin" })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var map = parse(html);
        if (!map) throw new Error("no rails");
        inject(map);
        state = 2;
        try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), m: map })); } catch (e) {}
      })
      .catch(function () { state = 0; });
  }

  var bar = root.querySelector(".navx-catbar");
  if (bar) {
    bar.addEventListener("pointerenter", load);
    bar.addEventListener("focusin", load);
  }
  Array.prototype.forEach.call(root.querySelectorAll(".navx-cat[data-panel]"), function (c) {
    c.addEventListener("click", load);
  });
  if (window.matchMedia && matchMedia("(min-width: 1024px) and (hover: hover) and (pointer: fine)").matches) {
    var later = function () {
      setTimeout(function () {
        (window.requestIdleCallback || function (f) { return setTimeout(f, 1); })(load, { timeout: 4000 });
      }, 1500);
    };
    if (document.readyState === "complete") later();
    else window.addEventListener("load", later, { once: true });
  }
})();
